export default __webpack_public_path__ + "static/media/F0001.698897f6.png";